import Actions from '../../odata/actions';

const actionsMovies = new Actions('movies', 'movies');
const actionsMovie = new Actions('movie', 'movies');

export default { ...actionsMovies, ...actionsMovie };
